<div class="riv-card" [ngClass]="{
    'riv-expanded': opened(),
    'riv-warn': item().classification === 'REGULAR',
    'riv-bad': item().classification === 'BAD'
}">
    <div class="riv-header" (click)="toggle()">
        @if (!isEditing()) {
            <div class="riv-status-circle" [ngClass]="{
                'riv-good': item().classification === 'GOOD',
                'riv-regular': item().classification === 'REGULAR',
                'riv-bad-circle': item().classification === 'BAD'
            }">
                @if (item().classification === 'GOOD') {
                    <span class="material-icons">check</span>
                } @else if (item().classification === 'REGULAR') {
                    <span class="material-icons">remove</span>
                } @else if (item().classification === 'BAD') {
                    <span class="material-icons">close</span>
                }
            </div>
        } @else {
            <div class="riv-status-edit" (click)="$event.stopPropagation()">
                <div class="riv-status-circle" [class.riv-good]="true" [class.riv-inactive]="item().classification !== 'GOOD'" (click)="statusChanged.emit('GOOD')">
                    <span class="material-icons">check</span>
                </div>
                <div class="riv-status-circle" [class.riv-regular]="true" [class.riv-inactive]="item().classification !== 'REGULAR'" (click)="statusChanged.emit('REGULAR')">
                    <span class="material-icons">remove</span>
                </div>
                <div class="riv-status-circle" [class.riv-bad-circle]="true" [class.riv-inactive]="item().classification !== 'BAD'" (click)="statusChanged.emit('BAD')">
                    <span class="material-icons">close</span>
                </div>
            </div>
        }

        <div class="riv-info">
            <span class="riv-name">{{ item().name }}</span>
            @if (!opened() && (item().description || item().fixingCost)) {
                <span class="riv-preview">{{ item().description }}</span>
            }
        </div>

        <div class="riv-right">
            @if (hasMedia()) {
                <button
                    type="button"
                    class="riv-media-seal"
                    (click)="openMediaViewer($event)"
                    [attr.aria-label]="'Ver ' + mediaTotal() + ' mídias'">
                    <i class="fa-solid fa-photo-film"></i>
                    <span class="riv-media-seal-count">{{ mediaTotal() }}</span>
                </button>
            }

            @if (!isEditing()) {
                @if (item().fixingCost) {
                    <span class="riv-cost-preview">{{ item().fixingCost | currency:'BRL':'symbol':'1.0-0' }}</span>
                    <span class="riv-separator">|</span>
                }

                <span class="riv-label" [ngClass]="{
                    'riv-label-good': item().classification === 'GOOD',
                    'riv-label-regular': item().classification === 'REGULAR',
                    'riv-label-bad': item().classification === 'BAD'
                }">
                    @if (item().classification === 'GOOD') { Bom }
                    @else if (item().classification === 'REGULAR') { Regular }
                    @else if (item().classification === 'BAD') { Ruim }
                </span>
            }
        </div>

        <span class="material-icons riv-chevron" [class.riv-chevron-up]="opened()">
            keyboard_arrow_down
        </span>
    </div>

    <div class="riv-body" [@expandCollapse]="opened() ? 'expanded' : 'collapsed'">
        <div class="riv-body-inner">
            <div class="riv-details-grid">
                <div class="riv-detail-section">
                    <span class="riv-section-label">COMENTÁRIO</span>
                    @if (!isEditing()) {
                        <div class="riv-section-value">{{ item().description || '-' }}</div>
                    } @else {
                        <mat-form-field appearance="fill" class="riv-edit-form-field" subscriptSizing="dynamic">
                            <input matInput [value]="item().description || ''" 
                                (input)="descriptionChanged.emit($any($event.target).value)" placeholder="Adicione um comentário..." />
                        </mat-form-field>
                    }
                </div>
                <div class="riv-detail-section">
                    <span class="riv-section-label">CUSTO ESTIMADO (R$)</span>
                    @if (!isEditing()) {
                        <div class="riv-section-value riv-cost-value">{{ (item().fixingCost | currency:'BRL') || '-' }}</div>
                    } @else {
                        <mat-form-field appearance="fill" class="riv-edit-form-field" subscriptSizing="dynamic">
                            <input matInput [ngModel]="item().fixingCost" 
                                (ngModelChange)="costChanged.emit($event)" placeholder="R$ 0,00"
                                currencyMask [options]="{
                                    prefix: 'R$ ',
                                    thousands: '.',
                                    precision: 2,
                                    allowNegative: false
                                }" />
                        </mat-form-field>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
